import { render, staticRenderFns } from "./DropAreaMulti.vue?vue&type=template&id=9c5725d8&scoped=true"
import script from "./DropAreaMulti.vue?vue&type=script&lang=ts"
export * from "./DropAreaMulti.vue?vue&type=script&lang=ts"
import style0 from "./DropAreaMulti.vue?vue&type=style&index=0&id=9c5725d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5725d8",
  null
  
)

export default component.exports